var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16Z",
    fill: "url(#paint0_radial_1_809)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 8.875C21.125 7 18.625 6 16 6C10.5 6 6 10.5 6 16C6 17.75 6.50001 19.5 7.37501 21L6 26L11.25 24.625C12.75 25.375 14.375 25.875 16 25.875C21.5 25.875 26 21.375 26 15.875C26 13.25 24.875 10.75 23 8.875ZM16 24.25C14.5 24.25 13 23.875 11.75 23.125L11.5 23L8.37499 23.875L9.25001 20.875L8.99999 20.5C8.12499 19.125 7.74999 17.625 7.74999 16.125C7.74999 11.625 11.5 7.875 16 7.875C18.25 7.875 20.25 8.75 21.875 10.25C23.5 11.875 24.25 13.875 24.25 16.125C24.25 20.5 20.625 24.25 16 24.25ZM20.5 18C20.25 17.875 19 17.25 18.75 17.25C18.5 17.125 18.375 17.125 18.25 17.375C18.125 17.625 17.625 18.125 17.5 18.375C17.375 18.5 17.25 18.5 17 18.5C16.75 18.375 16 18.125 15 17.25C14.25 16.625 13.75 15.75 13.625 15.5C13.5 15.25 13.625 15.125 13.75 15C13.875 14.875 14 14.75 14.125 14.625C14.25 14.5 14.25 14.375 14.375 14.25C14.5 14.125 14.375 14 14.375 13.875C14.375 13.75 13.875 12.5 13.625 12C13.5 11.625 13.25 11.625 13.125 11.625C13 11.625 12.875 11.625 12.625 11.625C12.5 11.625 12.25 11.625 12 11.875C11.75 12.125 11.125 12.75 11.125 14C11.125 15.25 12 16.375 12.125 16.625C12.25 16.75 13.875 19.375 16.375 20.375C18.5 21.25 18.875 21 19.375 21C19.875 21 20.875 20.375 21 19.875C21.25 19.25 21.25 18.75 21.125 18.75C21 18.125 20.75 18.125 20.5 18Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_809",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 16) rotate(90) scale(16)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25D366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18BD55"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.49020458050045162cd97eccb343ff79.svg";
export { ForwardRef as ReactComponent };